/* Copyright (c) 2015 Hyunje Alex Jun and other contributors
 * Licensed under the MIT License
 */
'use strict';

var destroy = require('./plugin/destroy')
  , initialize = require('./plugin/initialize')
  , update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/perfect-scrollbar/src/js/main.js
 ** module id = 790
 ** module chunks = 73
 **/